import { BACKEND_KEYS } from '../../common/consts/app-keys.const';
import { HttpFactoryService, HttpService } from '../../common/services';

class PricingService {
  httpService: HttpService;

  constructor(private httpFactory: HttpFactoryService) {
    this.httpService = httpFactory.createHttpService();
  }

  public async getCheckoutSession(duration: string) {
    const result = await this.httpService.get<{ url: string }>(
      `${BACKEND_KEYS.CHECKOUT_SESSION}?duration=${duration}`
    );
    return result;
  }

  public async getPrice(duration: string) {
    const result = await this.httpService.get<{ amount: number }>(
      `${BACKEND_KEYS.GET_PLAN_PRICE}?duration=${duration}`
    );
    return result;
  }

  public async startFreeTrial() {
    const result = await this.httpService.get<{
      success: boolean;
      expiresAt: string;
    }>(BACKEND_KEYS.FREE_TRIAL);
    return result;
  }

  public async getCustomerPortalUrl() {
    const result = await this.httpService.get<{ url: string }>(
      BACKEND_KEYS.GET_USER_PORTAL_URL
    );
    return result;
  }
}

const pricingService = new PricingService(new HttpFactoryService());

export { pricingService };
